import { render, staticRenderFns } from "./SwitchComponent.vue?vue&type=template&id=0f2cbce5&scoped=true&"
import script from "./SwitchComponent.vue?vue&type=script&lang=js&"
export * from "./SwitchComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2cbce5",
  null
  
)

export default component.exports